import React from 'react';
import { Alert, Button } from 'reactstrap';
import { getEventDisplayDate } from './LongTermSchedule';
import {
    faBackwardStep,
    faCancel,
    faExclamationTriangle,
    faInfoCircle,
    faMailBulk,
    faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash-es';
import LongTermScheduleCancelManager from './LongTermScheduleCancelManager';
import { AlertTitle } from '@mui/material';
import { Can } from '../Can';
import moment from 'moment';
import { toasty } from '../common/forms/FormElements';

export default class LongTermScheduleActionManager extends React.Component {
    getIsModified = () => {
        const { longTermSchedule, originalLongTermSchedule, job, originalJob } =
            this.props;

        // bugbug: there was a quiet array re-order happening, this helped me track that down
        // so I'm leaving this in case it's needed again
        // const customDeepComparison = (obj1, obj2) => {
        //     return _.transform(
        //         obj1,
        //         (result, value, key) => {
        //             if (!_.isEqual(value, obj2[key])) {
        //                 result[key] = value;
        //             }
        //         },
        //         {}
        //     );
        // };

        if (!job) {
            longTermSchedule.longTermScheduleContractPhases.sort((a, b) =>
                a.contractPhaseId < b.contractPhaseId ? -1 : 1
            );

            originalLongTermSchedule.longTermScheduleContractPhases.sort(
                (a, b) => (a.contractPhaseId < b.contractPhaseId ? -1 : 1)
            );
        }

        // console.debug(
        //     customDeepComparison(longTermSchedule, originalLongTermSchedule)
        // );

        return job
            ? !_.isEqual(job, originalJob)
            : !_.isEqual(longTermSchedule, originalLongTermSchedule);
    };

    getIsLocationValid = () => {
        const { longTermSchedule, arcGisLocations } = this.props;

        if (arcGisLocations && arcGisLocations.length > 0) {
            return Boolean(longTermSchedule.arcGisLocationId);
        }

        return longTermSchedule.roadName;
    };

    getIsProjectManagerSpecified = () => {
        const { longTermSchedule } = this.props;

        return Boolean(longTermSchedule?.projectManagerId);
    };

    getIsPublishAllowed = () => {
        const { longTermSchedule } = this.props;
        const isModified = this.getIsModified();

        return (
            longTermSchedule.id > 0 &&
            !isModified &&
            !longTermSchedule.mayNotBePublishedBecauseStartsInThePast
        );
    };

    onNotificationClick = () => {
        toasty.info(
            'For now, please use the dispatch board to send notifications.'
        );
    };

    render() {
        const {
            longTermSchedule,
            isCancelled,
            schedulers,
            job,
            isReleased,
            cancelWorkflowEnabled,
            eventDate,
            saving,
            toggleCancelMode,
            releaseDay,
            publishLongTermSchedule,
            assignmentConflicts,
            assignLongTermSchedule,
            anyNotificationsSent,
            changesSignaled,
        } = this.props;

        const eventGteToday = moment(eventDate).isSameOrAfter(moment(), 'day');

        if (!longTermSchedule) {
            return null;
        }

        const scheduler = schedulers.find(
            (e) => e.id == (job || {}).requestedById
        );

        const isModified = this.getIsModified();

        const isLocationValid = this.getIsLocationValid();

        const isProjectManagerSpecified = this.getIsProjectManagerSpecified();

        if (!longTermSchedule.isPublished) {
            const alertColor =
                longTermSchedule.isAssigned && longTermSchedule.projectManagerId
                    ? 'warning'
                    : 'danger';

            return (
                <>
                    {longTermSchedule.id > 0 && (
                        <Alert fade={false} color={alertColor}>
                            {longTermSchedule.projectManagerId && (
                                <div>
                                    This long-term schedule has not been
                                    published.
                                </div>
                            )}

                            {!longTermSchedule.isAssigned && (
                                <div>
                                    This has not been assigned to a project
                                    manager; only a long-term schedule
                                    administrator may publish it.
                                </div>
                            )}

                            {!longTermSchedule.projectManagerId && (
                                <div>
                                    <FontAwesomeIcon
                                        icon={faExclamationTriangle}
                                        className="mr-1"
                                    />{' '}
                                    You must add a project manager to publish.
                                </div>
                            )}
                        </Alert>
                    )}

                    {longTermSchedule.mayNotBePublishedBecauseStartsInThePast && (
                        <Alert fade={false} color="danger" className="mt-2">
                            <FontAwesomeIcon
                                icon={faExclamationTriangle}
                                className="mr-1"
                            />
                            This long-term schedule starts too far in the past
                            to be published.
                        </Alert>
                    )}

                    {assignmentConflicts.length > 0 && (
                        <Alert color="warning" fade={false}>
                            <AlertTitle>
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    className="mr-2"
                                />
                                Crew Assignment Conflicts Detected
                            </AlertTitle>
                            <div>
                                The following assignment conflicts have been
                                detected.
                                <ul>
                                    {assignmentConflicts.map((ac) => (
                                        <li key={ac}>{ac}</li>
                                    ))}
                                </ul>
                            </div>
                        </Alert>
                    )}

                    {this.getIsPublishAllowed() && (
                        <Can I="publish" a="longtermschedule">
                            <div className="mt-2 d-flex">
                                {!longTermSchedule.isAssigned &&
                                    longTermSchedule.projectManagerId && (
                                        <Can I="admin" a="longtermschedule">
                                            <Button
                                                color="success"
                                                type="button"
                                                onClick={assignLongTermSchedule}
                                                disabled={
                                                    !isProjectManagerSpecified
                                                }
                                                className="mr-5"
                                            >
                                                <FontAwesomeIcon
                                                    icon={faPaperPlane}
                                                    className="mr-1"
                                                />
                                                Assign
                                            </Button>
                                        </Can>
                                    )}

                                <div>
                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={publishLongTermSchedule}
                                        disabled={
                                            !isLocationValid ||
                                            !isProjectManagerSpecified
                                        }
                                    >
                                        Publish
                                    </Button>
                                </div>

                                {!isLocationValid && (
                                    <div className="ml-2 align-content-center">
                                        Location is invalid.
                                    </div>
                                )}
                            </div>
                        </Can>
                    )}

                    {longTermSchedule.id > 0 &&
                        !isModified &&
                        !longTermSchedule.mayNotBePublishedBecauseStartsInThePast && (
                            <Can not I="publish" a="longtermschedule">
                                <Alert color="danger" fade={false}>
                                    You are not permitted to publish this
                                    schedule.
                                </Alert>
                            </Can>
                        )}
                </>
            );
        }

        return (
            <>
                <Alert fade={false} color="success">
                    This long-term job has been published.
                    {scheduler && (
                        <div className="mt-2">
                            It was requested by {scheduler.fullName}.
                        </div>
                    )}
                    {isReleased && (
                        <div className="mt-2">
                            Crew assignments have already been released.
                            <span>
                                {' '}
                                Notifications have{' '}
                                {anyNotificationsSent
                                    ? 'been'
                                    : 'not been'}{' '}
                                sent.
                            </span>
                        </div>
                    )}
                </Alert>

                {changesSignaled && (
                    <Alert color="info" fade={false}>
                        <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
                        Changes have been made - please save to enable
                        release/cancel actions.
                    </Alert>
                )}

                {!isCancelled && !changesSignaled && (
                    <Can I="release" a="longtermschedule">
                        <Button
                            type="button"
                            color="warning"
                            outline={true}
                            onClick={toggleCancelMode}
                            className="w-100 xl mb-5"
                        >
                            {cancelWorkflowEnabled && (
                                <>
                                    <FontAwesomeIcon
                                        icon={faBackwardStep}
                                        className="mr-2"
                                    />
                                    Do Not Cancel{' '}
                                    {getEventDisplayDate(eventDate, job)}
                                </>
                            )}
                            {!cancelWorkflowEnabled && (
                                <>
                                    <FontAwesomeIcon
                                        icon={faCancel}
                                        className="mr-2"
                                    />
                                    Cancel {getEventDisplayDate(eventDate, job)}
                                </>
                            )}
                        </Button>
                    </Can>
                )}

                {isCancelled && (
                    <Alert color="info" fade={false}>
                        This date has already been cancelled.
                    </Alert>
                )}

                {eventDate &&
                    !isReleased &&
                    !isModified &&
                    !isCancelled &&
                    !changesSignaled &&
                    !cancelWorkflowEnabled && (
                        <Can I="release" a="longtermschedule">
                            <div>
                                <div>
                                    <Button
                                        type="button"
                                        color="success"
                                        onClick={releaseDay}
                                        disabled={saving}
                                        className="w-100 xl"
                                    >
                                        <FontAwesomeIcon
                                            icon={faMailBulk}
                                            className="mr-2"
                                        />
                                        Release{' '}
                                        {getEventDisplayDate(eventDate, job)}
                                    </Button>
                                </div>

                                {/*
                            <div className="mt-3">
                                <FormCheckbox
                                    name="alsoDispatchNotifications"
                                    checked={false} // was alsoDispatchNotifications
                                    onChange={this.onChange}
                                    labelText="Also dispatch notifications (open question: do we want this option?)"
                                    //disabled={saving}
                                    readOnly={true}
                                />
                            </div>
                            */}
                            </div>
                        </Can>
                    )}

                <LongTermScheduleCancelManager {...this.props} />

                {!cancelWorkflowEnabled &&
                    isReleased &&
                    !isCancelled &&
                    eventGteToday && (
                        <Button
                            type="button"
                            color="success"
                            onClick={this.onNotificationClick}
                            className="w-100 xl"
                        >
                            <FontAwesomeIcon
                                icon={faMailBulk}
                                className="mr-2"
                            />
                            Send / Re-send notifications to crew for{' '}
                            {getEventDisplayDate(eventDate, job)}
                        </Button>
                    )}
            </>
        );
    }
}
